<template>
  <div>
    <div class="d-flex align-center mb-4 h-35px px-1">
      <b-button-group class="ms-auto" size="sm">
        <button
          @click="addRule"
          :class="currentQuery.length >= parseInt(length) ? 'disabled' : ''"
          :disabled="currentQuery.length >= parseInt(length)"
          class="btn btn-outline-info"
        >
          <b-icon-plus-circle /> Add box
        </button>
      </b-button-group>
    </div>
    <template v-if="currentQuery.length === 0">
      <div class="text-center text-muted poppins-ls pb-8">
        {{ $t("no_data") }}
      </div>
    </template>
    <template v-else>
      <template v-for="(item, index) in currentQuery">
        <Action
          @delete-rule="deleteRule"
          :rule="item"
          :key="index"
          class="mt-2 px-1"
        />
      </template>
    </template>
  </div>
</template>

<script>
import Action from "@/own/components/fulfillment/orders/actionBuilder/Action.vue";
export default {
  name: "ActionGroup",
  components: { Action },
  props: {
    currentQuery: {
      type: Array,
      required: true,
    },
    length: {
      type: Number,
      required: true,
    },
  },
  methods: {
    deleteRule(number) {
      this.currentQuery.splice(
        this.currentQuery.findIndex((item) => item.number === number),
        1
      );
    },
    addRule() {
      const newGroup = {
        number: "box" + (this.currentQuery.length + 1),
        width: null,
        height: null,
        length: null,
        weight: null,
      };
      this.currentQuery.push(newGroup);
    },
  },
};
</script>
